export default "__VITE_ASSET__CbOOLotr__"